import _ from 'lodash'
import T from 'prop-types'
import React from 'react'
import { TextOverflow } from 'react-base'
import { pluralize, formatBytes } from 'pw-formatters'

export default class ImportedFileSummary extends React.Component {
  static displayName = 'ImportedFileSummary'

  static propTypes = {
    fileName: T.string,
    fileSize: T.number,
    invalidLines: T.arrayOf(T.object),
    lineLabel: T.string.isRequired,
    validLines: T.arrayOf(T.object)
  }

  state = {
    fileExpanded: false,
    validVisible: true,
    invalidVisible: true
  }

  _toggleInvalid = () => {
    if (!this.state.validVisible && this.state.invalidVisible) {
      return
    }
    this.setState({
      invalidVisible: !this.state.invalidVisible,
      fileExpanded: true
    })
  }

  _toggleValid = () => {
    if (this.state.validVisible && !this.state.invalidVisible) {
      return
    }
    this.setState({
      validVisible: !this.state.validVisible,
      fileExpanded: true
    })
  }

  _toggleFileExpanded = () => {
    this.setState({
      fileExpanded: !this.state.fileExpanded
    })
  }

  _getMergedData = () => {
    const { invalidLines, validLines } = this.props
    const { validVisible, invalidVisible } = this.state

    const output = []

    if (validVisible) {
      for (let i = 0, numValid = validLines.length; i < numValid; i++) {
        const validLine = validLines[i]
        output[validLine.lineNumber] = _.assign(validLine, {
          className: 'valid_file_line'
        })
      }
    }
    if (invalidVisible) {
      for (let i = 0, numInvalid = invalidLines.length; i < numInvalid; i++) {
        const invalidLine = invalidLines[i]
        output[invalidLine.lineNumber] = _.assign(invalidLine, {
          className: 'invalid_file_line'
        })
      }
    }
    return output
  }

  render() {
    const {
      fileName,
      fileSize,
      invalidLines,
      lineLabel,
      validLines
    } = this.props
    const { fileExpanded, validVisible, invalidVisible } = this.state

    const numValid = validLines.length
    const validLabel = pluralize(numValid, lineLabel)
    const numInvalid = invalidLines.length
    const invalidLabel = pluralize(numInvalid, 'Line')

    return (
      <div className={`file_summary`}>
        <header className={`file_header ${fileExpanded ? 'expanded' : ''}`}>
          <TextOverflow
            className="file_name"
            onClick={this._toggleFileExpanded}
          >
            {fileName} {fileSize && <span>{formatBytes(fileSize, true)}</span>}
          </TextOverflow>
          <div className="file_counts">
            <span
              className={`valid_ct ${validVisible ? 'active' : ''}`}
              data-tooltip={`${validVisible
                ? 'Hide'
                : 'Show'} Valid ${validLabel}`}
              onClick={this._toggleValid}
            >
              {numValid.toLocaleString()}{' '}
            </span>
            <span
              className={`invalid_ct ${invalidVisible ? 'active' : ''}`}
              data-tooltip={`${invalidVisible
                ? 'Hide'
                : 'Show'} Invalid ${invalidLabel}/${pluralize(
                numInvalid,
                lineLabel
              )}: `}
              onClick={this._toggleInvalid}
            >
              {numInvalid.toLocaleString()}
            </span>
          </div>
        </header>
        {fileExpanded
          ? <div className="file_details_expanded">
              {_.map(this._getMergedData(), (line, i) => {
                if (!line && (!validVisible || !invalidVisible)) {
                  return null // Do not render empty lines unless both types are visible
                }
                line = line || {}
                return (
                  <div
                    className={'file_line ' + line.className || 'line_blank'}
                    key={line.lineNumber || i}
                  >
                    <div className="line_number">
                      {(line.lineNumber || i) + 1}
                    </div>
                    <div>
                      {line.text || ''}
                    </div>
                  </div>
                )
              })}
            </div>
          : null}
      </div>
    )
  }
}